<script setup>
import {ref} from 'vue';
import {APIService} from '@ohrm/core/util/services/api.service';
import ReportTable from '@ohrm/oxd/core/components/ReportTable/ReportTable';

const isLoading = ref(false);
const rules = ref({
  fields: []
});
const fieldOptions = ref([
  { label: 'Title', id: 'title'},
  { label: 'ID', id: 'number'},
  { label: 'Training Type', id: 'trainingType'},
  { label: 'Participants', id: 'participants'},
  { label: 'Department(s)', id: 'departments'},
  { label: 'Trainer(s)', id: 'trainers'},
  { label: 'Start Date', id: 'startDate'},
  { label: 'Due Date', id: 'dueDate'},
  { label: 'Duration', id: 'duration'},
  { label: 'Status', id: 'status'},
  { label: 'Priority', id: 'priority'},
  { label: 'Effectiveness', id: 'effectiveness'},
  { label: 'Score', id: 'score'},
  { label: 'Participant Comment', id: 'comment'}
]);
const report = ref({
  fields: fieldOptions.value,
  from: null,
  to: null
});
const total = ref(0);
const items = ref([]);

const http = new APIService(
  window.appGlobal.baseUrl,
  '/api/v2/training/plan/get-report',
);

const onSearch = async () => {
  let normalizedFields = [];
  report.value.fields.forEach((field) => {
    normalizedFields.push(field.id);
  });
  normalizedFields = normalizedFields.join(',')

  await http
    .request({
      method: 'GET',
      params: {
        fields: normalizedFields,
        from: report.value.fromDate,
        to: report.value.toDate
      }
    })
    .then(response => {
      total.value = response.data.meta.total
      items.value = response.data.data
    });
}

const onExport = () => {
  let normalizedFields = [];
  report.value.fields.forEach((field) => {
    normalizedFields.push(field.id);
  });
  normalizedFields = normalizedFields.join(',')

  let url = `${window.appGlobal.baseUrl}/api/v2/training/plan/export?fields=${normalizedFields}`;
  if (report.value.from) {
    url = `${url}&from=${report.value.from}`
  }
  if (report.value.to) {
    url = `${url}&to=${report.value.to}`
  }
  window.open(url, '_blank');
}
</script>

<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        {{$t('training.training_plan_report')}}
      </oxd-text>

      <oxd-divider />

      <oxd-form :loading="isLoading" @submitValid="onSearch">
        <oxd-form-row>
          <oxd-grid :cols="4" class="orangehrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="report.fields"
                value="Select"
                type="multiselect"
                :label="$t('training.display_fields')"
                :options="fieldOptions"
                :rules="rules.fields"
                required
              />
            </oxd-grid-item>

            <oxd-grid-item>
              <date-input
                v-model="report.from"
                :label="$t('general.from_date')"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <date-input
                v-model="report.to"
                :label="$t('general.to_date')"
              />
            </oxd-grid-item>

          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button
            style="margin-right: 10px"
            display-type="secondary"
            :label="$t('admin.export_excel')"
            @click="onExport"
          />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>